/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const getApiProjectstatusesIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
});

/**
 * @description OK
 */
export const getApiProjectstatusesId200Schema = z.object({
  id: z.coerce.number().int().optional(),
  name: z.coerce.string(),
});

export const getApiProjectstatusesIdQueryResponseSchema = z.lazy(
  () => getApiProjectstatusesId200Schema,
);
